export class SqsQueuePolicyProbeError {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqsQueuePolicyProbeError.attributeTypeMap;
    }
    constructor() {
    }
}
